<template>
  <v-dialog
    v-model="editBalanceDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('users.editBalanceDialog.title') }}</b>
      </v-card-title>

      <v-card-text>
        <v-radio-group
          v-model="form.operation_type"
          hide-details
          class="mt-4 mb-6"
          row
        >
          <v-radio
            :label="$t('users.editBalanceDialog.deposit')"
            value="deposit"
          />
          <v-radio
            :label="$t('users.editBalanceDialog.withdraw')"
            value="withdraw"
          />
        </v-radio-group>
        <v-text-field
          v-model.trim="form.amount"
          name="amount"
          maxlength="12"
          :label="$t('users.editBalanceDialog.amount')+'*'"
          :suffix="'USDT'"
          :error-messages="AmountErrors"
          @input="$v.form.amount.$touch()"
          @blur="$v.form.amount.$touch()"
          @keypress="onlyForCurrency($event, form.amount)"
        />
        <v-text-field
          v-model="form.note"
          :label="$t('users.editBalanceDialog.note')"
          :counter="200"
        />
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="editBalanceDialog = false"
        >
          <span>{{ $t('globals.cancelButton') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading || ($v.$invalid)"
          :loading="loading"
          @click="editBalance()"
        >
          {{
            form.operation_type === 'withdraw' ? $t('users.editBalanceDialog.withdraw') : $t('users.editBalanceDialog.deposit')
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "vuelidate"
import {
  maxLength,
  required,
} from "vuelidate/lib/validators"
import USER_BALANCE_EDIT from "@/graphql/mutations/UserBalanceEdit.gql";

export default {
  name: "EditBalanceDialog",
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      default() {
        return null;
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        id: this.user.uuid,
        amount: null,
        operation_type: 'deposit',
        note: null,
      }
    };
  },
  validations() {
    return {
      form: this.rules
    };
  },
  computed: {
    editBalanceDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeEditBalanceDialog', val);
      }
    },
    rules() {
      return {
        amount: {
          required,
        },
        note: {maxLength: maxLength(200)},
      };
    },
    AmountErrors() {
      const errors = [];
      if (!this.$v.form.amount.$dirty) return errors;
      !this.$v.form.amount.required && errors.push(this.$t("projects.reqField"));
      return errors;
    },
  },
  methods: {
    async editBalance() {
      this.form.amount = parseFloat(this.form.amount)
      try {
        this.loading = true;
        await this.$apollo
            .mutate({
              mutation: USER_BALANCE_EDIT,
              variables: {
                user_uuid: this.form.id,
                amount: this.form.amount,
                action: this.form.operation_type,
                note: this.form.note
              },
            })
        this.$store.commit('app/setNotifier', this.$t('globals.success'));
      } catch (error) {
        this.errorHandler(error);
      }
      this.loading = false;
      this.editBalanceDialog = true;
    }
  },
};
</script>
